import React from 'react'
import { connect } from 'react-redux'
import Loader from 'components/D3Loader'
import { getUserRoleIdByStudy } from 'utils/misc'
import { USER_ROLE_ID_MAP } from 'utils/constants'
import { modalActions } from 'store/modal'

import { getHeaderName } from '../../../../../utils/visitNameUtils'
import { visitTemplateActions } from '../modules/VisitTemplate'
import VisitTemplatePage from '../components/VisitTemplatePage'
import { isVersionUatOrLive } from '../../../../../../../../../../../utils/studyConfigUtils'
import { hasMultipleArms } from 'utils/visitScheduleArms'

const mapDispatchToProps = { ...visitTemplateActions, ...modalActions }

const mapStateToProps = (state, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  const {
    loading,
    location,
    participants,
    study,
    subroute,
    user,
    visitTemplateReducer,
    studyLock,
    visitSchedules,
  } = state
  const { visitTemplateID } = ownProps.params
  const { currentStudy, studyVersionList } = study
  const path = location.pathname.match(/([^/]+$)/)[0]
  const studyID = currentStudy.id
  const roleId = getUserRoleIdByStudy(user, studyID)
  const isArmsSupported = study?.currentStudy?.config?.visit_support?.arms_enabled
  const isVisitCycleSupported = currentStudy?.config?.visit_support?.version > 1

  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  const isReadOnlyState = hasStudyPromotion && isVersionUatOrLive(studyVersionList, studyVersionID)

  return {
    subtitleName: getHeaderName(path, subroute, isArmsSupported, isReadOnlyState),
    visitorParticipantLoader: loading.visitorParticipant,
    isLoading: loading.general,
    isSiteCoord:
      roleId === USER_ROLE_ID_MAP.siteCoordinator ||
      roleId === USER_ROLE_ID_MAP.clinicalCoordinator ||
      roleId === USER_ROLE_ID_MAP.siteCoordinatorUAT ||
      roleId === USER_ROLE_ID_MAP.clinicalCoordinatorUAT ||
      roleId === USER_ROLE_ID_MAP.siteCoordinatorDEV ||
      roleId === USER_ROLE_ID_MAP.clinicalCoordinatorDEV,
    ...participants,
    path,
    isVisitTemplateEditor: path === 'edit',
    studyID,
    ...visitTemplateReducer,
    visitTemplateID,
    studyLock,
    isArmsSupported,
    isArmAllowedToDelete: hasMultipleArms(visitSchedules?.studyVisitSchedule),
    studyVisitSchedule: visitSchedules?.studyVisitSchedule,
    isReadOnlyState,
    studyVersionID,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(props => {
  return props.isLoading ? <Loader active /> : <VisitTemplatePage {...props} />
})
